import { form } from '../../../formState'

import * as OrderTexts from '../../../../../../intl'

const NAME_MAX_LENGTH = 100

export function Name() {
  form.useAddFieldValidation('order.name', (field, _formApi) => {
    if (!field.value || field.value.trim().length === 0) {
      return OrderTexts.getValidationErrorNameText()
    }

    if (field.value && field.value.length > NAME_MAX_LENGTH) {
      return OrderTexts.getValidationErrorMaxLengthText(NAME_MAX_LENGTH)
    }
  })

  return (
    <form.TextField label={OrderTexts.getFieldLabelNameText()} name="order.name" testId="name" />
  )
}
